import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'csn-authorization',
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthorizationComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.route.queryParams.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      // Phase 1 compat: server still includes ?token= in redirect for backward compatibility.
      // We do not store the token — the httpOnly cookie was already set by the server.
      // Phase 3 will remove the ?token= param once this frontend ships.
      const token = params['token'];
      let returnUrl = localStorage.getItem('returnUrl');
      if (!returnUrl) {
        returnUrl = '/home';
      }

      if (token) {
        localStorage.removeItem('returnUrl');
        this.authenticationService.setAuthenticated();
        this.router.navigateByUrl(returnUrl);
      }
      else {
        this.router.navigateByUrl('/')
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
